import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMenuMain = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 22 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M20 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H20C21.1 18 22 17.1 22 16V2C22 0.9 21.1 0 20 0ZM20 16H2V2H20V16ZM4 7H13V9H4V7ZM4 4H13V6H4V4Z",
		fill: "currentColor"
	})
});
export default SvgMenuMain;
